<a
  *ngIf="service"
  [href]="service.url"
  target="_blank"
  mat-raised-button
  color="accent"
  class="upi-pay1"
  [ngClass]="style?.variant"
  [ngStyle]="style"
>
  <image-or-icon class="inherit-size" src="/assets/images/widgets/upi.webp"></image-or-icon>
  <div class="content">Pay Via UPI</div>
</a>